module.exports = __webpack_public_path__ + "static/media/VanamaliLogo.0b60e088.png";